
import React from 'react'
import { connect } from 'react-redux'
// import AccountFilter from '../components/Hybrid/filter-account'
import AccountFilter from '../components/CloudProviders/filter-account';

import {
  searchAccount,
  selectAccount,
  selectRegion,
  selectCreated,
  selectCost,
  selectUsage,
  selectUsageRange,
  selectCostRange
} from '../actions/cloud-accounts-actions'

const mapStateToProps = ({ cloudAccounts }) =>{
  return {
    ...cloudAccounts,
    expanded: cloudAccounts.expandedItemId !== null
  }
}

const mapDispatchToProps = (dispatch) => ({
  handleSearch           : search             => dispatch(searchAccount(search)),
  handleAccountChange    : selectedAccount    => dispatch(selectAccount(selectedAccount)),
  handleRegionChange     : selectedRegion     => dispatch(selectRegion(selectedRegion)),
  handleCreatedChange    : selectedCreated    => dispatch(selectCreated(selectedCreated)),
  handleUsageChange      : selectedUsage      => dispatch(selectUsage(selectedUsage)),
  handleUsageRangeChange : selectedUsageRange => dispatch(selectUsageRange(selectedUsageRange)),
  handleCostChange       : selectedCost       => dispatch(selectCost(selectedCost)),
  handleCostRangeChange  : selectedCostRange  => dispatch(selectCostRange(selectedCostRange))
})

export default connect(mapStateToProps, mapDispatchToProps)(AccountFilter)
